import { Box, Flex, xcss } from '@atlaskit/primitives';
import { RovoThinkingBar } from '@atlassian/rovo-platform-ui-components/loading-state/RovoThinkingBar';
import { RovoThinkingBarWrapper } from '@atlassian/rovo-platform-ui-components/loading-state/RovoThinkingBarWrapper';
import { useLocale } from '@databases/intl';
import React from 'react';
import { IntlProvider } from 'react-intl';

const fixedThinkingBarContainerStyles = xcss({
  position: 'fixed',
  bottom: '36px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '400px',
  minWidth: 'fit-content',
  zIndex: 'modal'
});

const inlineThinkingBarContainerStyles = xcss({
  marginInline: 'auto',
  width: 'min(400px, 100%)'
});

export type DatabaseThinkingBarProps = {
  status: 'analyzing' | 'editing';
  onStop: () => void;
  isComplete?: boolean;
  onCompleteAnimationFinished?: () => void;
  startedAt?: number;
  placement?: 'fixed' | 'inline';
};

export const DatabaseThinkingBar = ({
  status,
  onStop,
  isComplete,
  onCompleteAnimationFinished,
  startedAt,
  placement = 'fixed'
}: DatabaseThinkingBarProps) => {
  const locale = useLocale();

  /**
   * The Rovo component and Databases use different react-intl contexts.
   */
  return (
    <IntlProvider locale={locale}>
      <Box
        xcss={
          placement === 'fixed'
            ? fixedThinkingBarContainerStyles
            : inlineThinkingBarContainerStyles
        }
        testId="database-thinking-bar"
      >
        <RovoThinkingBarWrapper isThinking>
          <Flex alignItems="center" justifyContent="space-between">
            <RovoThinkingBar
              status={status}
              onStop={onStop}
              showProgressBar
              isComplete={isComplete}
              onCompleteAnimationFinished={onCompleteAnimationFinished}
              useRotatingTitle
              startedAt={startedAt}
            />
          </Flex>
        </RovoThinkingBarWrapper>
      </Box>
    </IntlProvider>
  );
};
